export const e164ToPhone = (e164?: string) => {
    if (e164?.length === 12 && e164[0] === '+') {
        return `(${e164.slice(2, 5)}) ${e164.slice(5, 8)}-${e164.slice(8, 12)}`
    }
    else if (e164?.length === 11 && e164[0] !== '+') {
        return `(${e164.slice(1, 4)}) ${e164.slice(4, 7)}-${e164.slice(7, 11)}`
    }
    else if (e164?.length === 10 && e164[0] !== '1') {
        return `(${e164.slice(0, 3)}) ${e164.slice(3, 6)}-${e164.slice(6, 10)}`
    }

    return e164
}
export const phoneToE164 = (phoneNumber?: string) => {
    let phone = phoneNumber?.replace(/[^0-9]/g, '')
    if (phone?.length === 10) {
        phone = `+1${phone}`
    }
    else if (phone?.length === 11 && phone[0] === '1') {
        phone = `+${phone}`
    }
    return phone
}

export const formatPhoneNumber = (phoneNumber?: string) => {
    return e164ToPhone(phoneToE164(phoneNumber)) ?? ''
}
